import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  en: {
    translation: {
      title: "Customer Care",
      retail: "RETAIL",
      enterprise: "ENTERPRISE",
      call: "Call Us",
      email: "Email",
      headOffice: "Head Office",
      zonalOffice: "Zonal Offices",
      "Customer Care": "Customer Care",
      "Appellate Authority": "Appellate Authority",
      // ENGLISH
      address: "Address",
      city: "Ludhiana",
      Name: "Name",
      lsaPerson: "Ammit Bhatt",
      fullAddress:
        "Netplus Broadband Services Pvt Ltd. 5th floor The Grand Walk Mall, H Block Ludhiana 141012",
      viewMap: "View Google Map",
      "Complaint Resolution Timelines": "Complaint Resolution Timelines",
      resolutionTime: "Within 4 to 6 Hours",
    },
  },
  hi: {
    translation: {
      title: "ग्राहक सेवा",
      retail: "रिटेल",
      enterprise: "एंटरप्राइज़",
      call: "हमें कॉल करें",
      email: "ईमेल",
      headOffice: "मुख्य कार्यालय",
      zonalOffice: "क्षेत्रीय कार्यालय",
      "Customer Care": "ग्राहक सेवा",
      "Appellate Authority": "अपील प्राधिकरण",
      // HINDI
      address: "पता",
      city: "लुधियाना",
      fullAddress:
        "नेटप्लस ब्रॉडबैंड सर्विसेज प्राइवेट लिमिटेड, 5वीं मंजिल, द ग्रैंड वॉक मॉल, एच ब्लॉक, लुधियाना 141012",
      viewMap: "गूगल मैप देखें",
      Name: "नाम",
      lsaPerson: "अमित भट्ट",
      "Complaint Resolution Timelines": "शिकायत समाधान समय सीमा",
      resolutionTime: "4 से 6 घंटे के भीतर",
    },
  },
  pa: {
    translation: {
      title: "ਗਾਹਕ ਸੇਵਾ",
      retail: "ਰਿਟੇਲ",
      enterprise: "ਐਂਟਰਪ੍ਰਾਈਜ਼",
      call: "ਸਾਨੂੰ ਕਾਲ ਕਰੋ",
      email: "ਈਮੇਲ",
      headOffice: "ਮੁੱਖ ਦਫ਼ਤਰ",
      zonalOffice: "ਜ਼ੋਨਲ ਦਫ਼ਤਰ",
      "Customer Care": "ਗਾਹਕ ਸੇਵਾ",
      "Appellate Authority": "ਅਪੀਲ ਅਥਾਰਟੀ",
      // PUNJABI
      address: "ਪਤਾ",
      city: "ਲੁਧਿਆਣਾ",
      fullAddress:
        "ਨੈਟਪਲੱਸ ਬ੍ਰਾਡਬੈਂਡ ਸਰਵਿਸਿਜ਼ ਪ੍ਰਾਈਵੇਟ ਲਿਮਿਟਡ, 5ਵੀਂ ਮੰਜ਼ਿਲ, ਦ ਗ੍ਰੈਂਡ ਵਾਕ ਮਾਲ, ਐਚ ਬਲਾਕ, ਲੁਧਿਆਣਾ 141012",
      viewMap: "ਗੂਗਲ ਮੈਪ ਵੇਖੋ",
      Name: "ਨਾਮ",
      lsaPerson: "ਅਮਿਤ ਭੱਟ",
      "Complaint Resolution Timelines": "ਸ਼ਿਕਾਇਤ ਨਿਵਾਰਣ ਸਮਾਂ ਸੀਮਾ",
      resolutionTime: "4 ਤੋਂ 6 ਘੰਟਿਆਂ ਵਿੱਚ",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
